/**
 * Lightning-Host aus der projektbezogenen SF-URL ableiten
 * (`project.salesforce_url = ${instanceUrl}/${recordId}`, instanceUrl =
 * https://<myDomain>.my.salesforce.com). Lightning-Deeplinks brauchen den Lightning-Host
 * (…lightning.force.com), nicht die my.salesforce.com-Instanz — nur dort rendert die
 * Datei-Vorschau (z. B. PPTX). Greift auch für Sandboxes. null bei fehlender/ungültiger URL.
 */
export function sfLightningBaseUrl(salesforceUrl: string | null | undefined): string | null {
  if (!salesforceUrl) return null;
  try {
    const origin = new URL(salesforceUrl).origin;
    if (!origin.includes('.my.salesforce.com')) return null;
    return origin.replace('.my.salesforce.com', '.lightning.force.com');
  } catch {
    return null;
  }
}

/** Lightning-View-URL einer Datei (ContentDocument 069…). Muster wie in attachment-list.tsx. */
export function sfContentDocumentUrl(lightningBase: string, contentDocumentId: string): string {
  return `${lightningBase}/lightning/r/ContentDocument/${contentDocumentId}/view`;
}
